import ds from 'Shared/ds';
import app from 'Shared/app';
import modal from 'Shared/modal';
import form from './form-api';
import DocumentApi from './document-api';
import CartApi from './cart-api';

//import AccountApi from './account-api';
//import AddressApi from './address-api';
//import UserApi from './user-api';
//import SubAccountApi from './subaccount-api';
//import CheckoutApi from './checkout-api';
//import BudgetApi from './budget-api';
//import OrderListApi from './orderlist-api';
//import ProductApi from './product-api';

import NvApi from './nv-api';
import SalesRepApi from './salesRep-api';
import ReturnsApi from './returns-api';

class ApiModule
{
    ds = ds;
    app = app;
    form = form;
    modal = modal;
    //account = new AccountApi();
    //address = new AddressApi();
    //user = new UserApi();
    //subaccount = new SubAccountApi();
    cart = CartApi;
    //checkout = new CheckoutApi();
    //budget = new BudgetApi();
    //orderlist = OrderListApi;
    //product = new ProductApi();
    document = DocumentApi;
    nvApi = NvApi;
    salesRep = SalesRepApi;
    returns = ReturnsApi;
}

export default new ApiModule();